/** URL- and filesystem-safe file name: one rule for archive names, S3 keys and the names a download saves under. */
export function sanitizeFileName(fileName: string, fallback = 'archive', maxLength = 100): string {
  if (!fileName?.trim()) return fallback;

  const sanitized = fileName
    .replace(/[<>:"/\\|?*#&%]/g, '')
    // Control bytes corrupt S3 keys and Content-Disposition; zero-width and bidi overrides let a
    // roster-typed name visually reorder the file name in the photographer's Downloads folder.
    // eslint-disable-next-line no-control-regex -- stripping control bytes is this line's purpose
    .replace(/[\u0000-\u001f\u007f-\u009f\u200b-\u200f\u202a-\u202e\u2066-\u2069]/g, '')
    .replace(/\s+/g, '_')
    .replace(/_{2,}/g, '_')
    .replace(/^_+|_+$/g, '')
    .substring(0, maxLength);

  return sanitized || fallback;
}
